import styled from 'styled-components'

export const LoadingContainer = styled.div`
  width: 100%;
  height: 100%;
  align-content: center;
  align-items: center;
  justify-content: center;
`

export const ItemsContainer = styled.div`
  width: 100%;
  flex: 1;
  padding: 20px;
  flex-direction: column;
`
